const swiperAlbums = {
  0: {
    image:
      "https://fictionalrecords004232c4232647c6a10668cb4de31c163357-staging.s3.us-east-1.amazonaws.com/slider/white-stripes.jpg",
    title: "White Stripes",
    artist: "White Stripes",
  },
  1: {
    image:
      "https://fictionalrecords004232c4232647c6a10668cb4de31c163357-staging.s3.us-east-1.amazonaws.com/slider/okComputer.jpg",
    title: "OK Computer",
    artist: "Radiohead",
  },
  2: {
    image:
      "https://fictionalrecords004232c4232647c6a10668cb4de31c163357-staging.s3.us-east-1.amazonaws.com/slider/johncoltraneandjohnnyhartman.jpg",
    title: "John Coltrane & Johnny Hartman",
    artist: "John Coltrane & Johnny Hartman",
  },
  3: {
    image:
      "https://fictionalrecords004232c4232647c6a10668cb4de31c163357-staging.s3.us-east-1.amazonaws.com/slider/Like-Clockwork-Queens-of-the-Stone-Age-album-cover.jpg",
    title: "Like Clockwork",
    artist: "Queens of the Stone Age",
  },
  4: {
    image:
      "https://fictionalrecords004232c4232647c6a10668cb4de31c163357-staging.s3.us-east-1.amazonaws.com/slider/king-krule-ooz.jpg",
    title: "The OOZ",
    artist: "King Krule",
  },
  5: {
    image:
      "https://fictionalrecords004232c4232647c6a10668cb4de31c163357-staging.s3.us-east-1.amazonaws.com/slider/HSOR53.jpg",
    title: "HORSESHIT ON ROUTE 66",
    artist: "The Garden",
  },
  6: {
    image:
      "https://fictionalrecords004232c4232647c6a10668cb4de31c163357-staging.s3.us-east-1.amazonaws.com/slider/oh-sees-orc.jpg",
    title: "Orc",
    artist: "Oh Sees",
  },
  7: {
    image:
      "https://fictionalrecords004232c4232647c6a10668cb4de31c163357-staging.s3.us-east-1.amazonaws.com/slider/comdownMachine.jpg",
    title: "The Strokes",
    artist: "Comedown Machine",
  },
};

export default swiperAlbums;